import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CompanyService } from 'src/app/setting/services/company.service';
import { Employee } from '../../../../employee/models/Employee';

@Component({
    selector: 'app-attendance-indicator-settings',
    templateUrl: './attendance-indicator-settings.component.html',
    styleUrls: ['./attendance-indicator-settings.component.css']
})
export class AttendanceIndicatorSettingsComponent implements OnInit {
    @Input() public settings: any;
    @Input() public employees: Employee[];

    public form: UntypedFormGroup;
    public fondTypes = [
        {value: 'percent', label: this._translateService.instant('settings.fond_type_percent')},
        {value: 'hour', label: this._translateService.instant('settings.fond_type_hour')},
    ];

    public constructor(
        private _companyService: CompanyService,
        private _fb: UntypedFormBuilder,
        private _translateService: TranslateService,
    ) { }

    public get f(): { [formControlName: string]: AbstractControl; } {
        return this.form.controls;
    }

    public ngOnInit(): void {
        this.form = this._fb.group({
            'company.attendance.highlight_daily_hour_work_fond': ['', Validators.required],
            'company.attendance.highlight_excluded_employees': [[]],
            'company.attendance.highlight_daily_hour_work_fond_unit': ['percent'],
            'company.attendance.highlight_daily_hour_work_fond_treshold': [90],
        });

        this.form.patchValue({
            'company.attendance.highlight_daily_hour_work_fond': this.settings.company_settings.attendance.highlight_daily_hour_work_fond === '1',
            'company.attendance.highlight_excluded_employees': this.settings.company_settings.attendance.highlight_excluded_employees,
            'company.attendance.highlight_daily_hour_work_fond_unit': this.settings.company_settings.highlight_daily_hour_work_fond_unit || 'percent',
            'company.attendance.highlight_daily_hour_work_fond_treshold': this.settings.company_settings.highlight_daily_hour_work_fond_treshold || 90,
        });
    }

    public onSubmit(): void {
        const value = this.form.value;

        value.settings_type = 'attendance';

        void this._companyService.saveCompanySetting(this.form.value);
    }
}
